#import "../../../../../../common/graphql/EntityUserMessageFields.graphql"
query SupplierMessages(
  $id: UUID!
  $first: Int
  $after: Cursor
  $filter: UserMessageFilter
) {
  supplier(id: $id) {
    id
    userMessagesByEntityId(
      first: $first
      after: $after
      orderBy: _CREATED_DATE_DESC
      filter: $filter
    ) {
      nodes {
        ...EntityUserMessageFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
}
